import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const ConfidentialiteComponent = () => {
    return (
        <Container maxWidth="md" sx={{ backgroundColor: '#141414', color: '#fff', padding: '2rem', borderRadius: '10px', marginTop: '2rem' }}>
            <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: '1.5rem', textAlign: 'center' }}>
                Politique de Confidentialité
            </Typography>

            <Box>
                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>1. Introduction</Typography>
                <Typography paragraph>
                    La présente politique de confidentialité décrit la manière dont nous collectons, utilisons et protégeons vos données personnelles dans le cadre de l'utilisation de l'application K-Drama Tracker.
                </Typography>

                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>2. Responsable du Traitement des Données</Typography>
                <Typography paragraph>
                    Le responsable du traitement des données est K-Drama Tracker. Vous pouvez nous contacter à codeandhdw@gmail.com pour toute question relative à vos données personnelles.
                </Typography>

                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>3. Données Collectées</Typography>
                <Typography paragraph>
                    Nous collectons les données suivantes :
                </Typography>
                <ul>
                    <li>Informations d'identification : nom, adresse e-mail, etc.</li>
                    <li>Données de connexion : adresse IP, informations de session.</li>
                    <li>Informations sur l'utilisation de l'Application : favoris, k-dramas visionnés, etc.</li>
                </ul>

                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>4. Finalité du Traitement des Données</Typography>
                <Typography paragraph>
                    Vos données personnelles sont collectées et traitées pour les finalités suivantes :
                </Typography>
                <ul>
                    <li>Fournir et améliorer nos services.</li>
                    <li>Gérer votre compte utilisateur et vos préférences.</li>
                    <li>Envoyer des notifications concernant les mises à jour ou les promotions.</li>
                </ul>

                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>5. Partage des Données</Typography>
                <Typography paragraph>
                    Nous ne partageons pas vos données personnelles avec des tiers, sauf dans les cas suivants :
                </Typography>
                <ul>
                    <li>Lorsque vous nous avez donné votre consentement explicite.</li>
                    <li>Lorsque cela est nécessaire pour l'exécution de nos services.</li>
                    <li>En cas d'obligation légale ou de demande d'une autorité judiciaire.</li>
                </ul>

                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>6. Durée de Conservation des Données</Typography>
                <Typography paragraph>
                    Vos données sont conservées aussi longtemps que nécessaire pour l'exécution des services, ou conformément aux exigences légales en vigueur.
                </Typography>

                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>7. Vos Droits (Conformément au RGPD)</Typography>
                <Typography paragraph>
                    En vertu du Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :
                </Typography>
                <ul>
                    <li>Droit d'accès : vous pouvez demander une copie de vos données personnelles.</li>
                    <li>Droit de rectification : vous pouvez corriger toute information inexacte.</li>
                    <li>Droit à l'effacement : vous pouvez demander la suppression de vos données.</li>
                    <li>Droit à la portabilité : vous pouvez demander que vos données soient transférées à une autre entité.</li>
                </ul>
                <Typography paragraph>
                    Pour exercer ces droits, veuillez nous contacter à codeandhdw@gmail.com.
                </Typography>

                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>8. Sécurité des Données</Typography>
                <Typography paragraph>
                    Nous mettons en œuvre des mesures techniques et organisationnelles pour protéger vos données contre tout accès non autorisé, altération ou suppression.
                </Typography>

                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>9. Cookies et Technologies Similaires</Typography>
                <Typography paragraph>
                    Nous utilisons des cookies et des technologies similaires pour améliorer votre expérience utilisateur. Vous pouvez gérer vos préférences de cookies via les paramètres de votre navigateur.
                </Typography>

                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>10. Modifications de la Politique de Confidentialité</Typography>
                <Typography paragraph>
                    Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. Les modifications prendront effet dès leur publication sur l'Application.
                </Typography>

                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>11. Contact</Typography>
                <Typography paragraph>
                    Pour toute question ou demande concernant vos données personnelles, vous pouvez nous contacter à codeandhdw@gmail.com..
                </Typography>

                <Typography variant="body2" sx={{ marginTop: '2rem', fontStyle: 'italic', color: '#888' }}>
                    © 2024 K-Drama Tracker. Tous droits réservés.
                </Typography>
            </Box>
        </Container>
    );
};

export default ConfidentialiteComponent;
